import { render, staticRenderFns } from "./SurveyStep3.vue?vue&type=template&id=0a68656f&scoped=true&"
import script from "./SurveyStep3.vue?vue&type=script&lang=js&"
export * from "./SurveyStep3.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStep3.vue?vue&type=style&index=0&id=0a68656f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a68656f",
  null
  
)

export default component.exports